module.exports = __webpack_public_path__ + "img/vmware-digitalfoundation.9e2317ef.webp";